import {
  userPositionNames,
  userPositions
} from 'features/ManageUserDialog/userTitleTypes'
import { userRoleLevels } from 'features/UserPermissions'
import DownloadLink from 'features/UserPermissions/DownloadLink'
import { useSelector } from 'react-redux'

import { selectIsInternalAdmin } from '../../accessors/index'
import { formatPhoneNumber } from '../../utils/helpers'
import { ReactComponent as DeleteIcon } from './delete.svg'
import { ReactComponent as EditIcon } from './edit.svg'

const UserInfo = ({
  handleDeleteClick,
  handleEditClick,
  name,
  email,
  id,
  phone,
  position,
  onClickManageInGroup,
  isInvoiceRecipient
}) => {
  const isInternalAdmin = useSelector(selectIsInternalAdmin)

  const isIndependentlyManaged = useSelector(s => s.hotelDetails.isIndependentlyManaged)

  const userManageRole = useSelector(s => s.login.roles.UserManage)

  const canEditUsers =
    [userRoleLevels.HasPermission, userRoleLevels.HasGroupLevelPermission].includes(
      userManageRole
    ) || isInternalAdmin

  return (
    <div className="userInfo">
      <div className="userInfo__name">
        {name}
        <div className="userInfo__controls">
          {canEditUsers && (
            <>
              <button onClick={() => handleEditClick(id)}>
                <EditIcon />
              </button>
              <button onClick={() => handleDeleteClick(name, id, email)}>
                <DeleteIcon />
              </button>
            </>
          )}
        </div>
      </div>
      <p
        className="userInfo__email"
        data-tip={email && (email.length > 23 ? email : null)}
      >
        {isInvoiceRecipient && (
          <svg
            width="15"
            height="18"
            viewBox="0 0 13 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginRight: 5, position: 'relative', top: -3, flexShrink: 0 }}
          >
            <path
              d="M12.4083 0H0.575221C0.262958 0 0 0.262958 0 0.575221V14.7421C0 15.0215 0.147914 15.2845 0.394437 15.4159C0.64096 15.5474 0.936788 15.531 1.16688 15.3831L2.18584 14.6928C2.39949 14.5613 2.66245 14.5613 2.87611 14.6928L4.09229 15.4981C4.33882 15.6625 4.66751 15.6625 4.93047 15.4981L6.14665 14.6928C6.36031 14.5613 6.62326 14.5613 6.83692 14.6928L8.0531 15.4981C8.18458 15.5803 8.33249 15.6296 8.46397 15.6296C8.61189 15.6296 8.7598 15.5803 8.89128 15.4981L10.1075 14.6928C10.3211 14.5613 10.5841 14.5613 10.7977 14.6928L11.8331 15.3831C12.0632 15.531 12.359 15.5474 12.6056 15.4159C12.8521 15.2845 13 15.0215 13 14.7421V0.575221C12.9836 0.262958 12.7206 0 12.4083 0ZM2.7775 3.07332H6.47535C6.70544 3.07332 6.90266 3.25411 6.90266 3.50063C6.90266 3.73072 6.72187 3.92796 6.47535 3.92796H2.7775C2.54741 3.92796 2.35019 3.74715 2.35019 3.50063C2.35019 3.25411 2.54741 3.07332 2.7775 3.07332ZM2.7775 5.68649H6.47535C6.70544 5.68649 6.90266 5.86727 6.90266 6.1138C6.90266 6.34389 6.72187 6.5411 6.47535 6.5411H2.7775C2.54741 6.5411 2.35019 6.36032 2.35019 6.1138C2.35019 5.88371 2.54741 5.68649 2.7775 5.68649ZM10.1732 11.751H2.7775C2.54741 11.751 2.35019 11.5702 2.35019 11.3237C2.35019 11.0771 2.53097 10.8963 2.7775 10.8963H10.1732C10.4033 10.8963 10.6005 11.0771 10.6005 11.3237C10.6005 11.5702 10.4033 11.751 10.1732 11.751ZM10.1732 9.13782H2.7775C2.54741 9.13782 2.35019 8.95703 2.35019 8.71051C2.35019 8.48042 2.53097 8.2832 2.7775 8.2832H10.1732C10.4033 8.2832 10.6005 8.46399 10.6005 8.71051C10.5841 8.95703 10.4033 9.13782 10.1732 9.13782ZM10.4526 6.29458C10.2718 6.4918 10.0253 6.60684 9.71302 6.63971V7.03415C9.71302 7.08346 9.68015 7.11633 9.63085 7.11633H9.21998C9.17067 7.11633 9.1378 7.08346 9.1378 7.03415V6.62328C8.74336 6.55754 8.39823 6.39319 8.08597 6.1138C8.0531 6.08093 8.0531 6.03162 8.08597 5.99875L8.4311 5.58788C8.46397 5.55501 8.51328 5.55501 8.54615 5.57145C8.67762 5.68649 8.8091 5.76866 8.95702 5.8344C9.1378 5.90014 9.30215 5.94945 9.45006 5.94945C9.58154 5.94945 9.69659 5.91658 9.77876 5.85084C9.86094 5.7851 9.91024 5.70293 9.91024 5.60432C9.91024 5.57145 9.91024 5.52214 9.89381 5.48927C9.87737 5.4564 9.86094 5.42353 9.8445 5.39066C9.82807 5.35779 9.7952 5.34136 9.76233 5.30849C9.72946 5.29205 9.69659 5.25918 9.64728 5.24275C9.59798 5.22631 9.54867 5.19344 9.48293 5.17701C9.43363 5.16057 9.35145 5.1277 9.28572 5.11127C9.21998 5.09483 9.15424 5.0784 9.10493 5.06196C9.05563 5.04553 8.98989 5.0291 8.92415 4.99623C8.85841 4.97979 8.8091 4.94692 8.7598 4.93049C8.71049 4.91405 8.66119 4.88118 8.61189 4.84831C8.56258 4.81544 8.51328 4.78257 8.48041 4.7497C8.44754 4.71683 8.39823 4.68396 8.36536 4.65109C8.33249 4.61822 8.29962 4.56892 8.26675 4.51961C8.23388 4.47031 8.21745 4.421 8.20101 4.3717C8.18458 4.32239 8.16814 4.25666 8.15171 4.20735C8.13527 4.14161 8.13527 4.07587 8.13527 4.01013C8.13527 3.73072 8.21745 3.4842 8.39823 3.28698C8.57902 3.08976 8.82554 2.97471 9.1378 2.94184V2.54741C9.1378 2.4981 9.17067 2.46523 9.21998 2.46523H9.63085C9.68015 2.46523 9.71302 2.4981 9.71302 2.54741V3.02402C9.87737 3.05689 10.0417 3.12263 10.2225 3.18837C10.354 3.25411 10.4855 3.31985 10.5841 3.40202C10.6169 3.43489 10.6334 3.4842 10.6005 3.51707L10.2718 3.92796C10.2389 3.96083 10.1896 3.96083 10.1568 3.94439C9.89381 3.76359 9.63085 3.68141 9.36789 3.68141C9.23641 3.68141 9.12137 3.71428 9.03919 3.76359C8.95702 3.81291 8.92415 3.89509 8.92415 3.9937C8.92415 4.09231 8.97345 4.17448 9.05563 4.22379C9.1378 4.28952 9.28572 4.35526 9.49937 4.421C9.59798 4.45387 9.66372 4.47031 9.72946 4.50318C9.7952 4.51961 9.86094 4.55248 9.94311 4.58535C10.0253 4.61822 10.091 4.63466 10.1403 4.66753C10.1896 4.7004 10.2554 4.73327 10.3047 4.76614C10.3704 4.79901 10.4033 4.83188 10.4526 4.88118C10.4855 4.91405 10.5348 4.96336 10.5676 5.01266C10.6005 5.06196 10.6334 5.11127 10.6498 5.17701C10.6662 5.22631 10.6827 5.29205 10.6991 5.35779C10.7156 5.42353 10.7156 5.50571 10.7156 5.58788C10.7156 5.86727 10.6334 6.09736 10.4526 6.29458Z"
              fill="#4079F5"
            />
          </svg>
        )}
        <span
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
        >
          {email}
        </span>
      </p>
      <p className="userInfo__email">{formatPhoneNumber(phone)}</p>
      {position && position !== userPositions.Unknown && (
        <span className="userInfo__role-pill">{userPositionNames[position]}</span>
      )}
      {isInternalAdmin && !isIndependentlyManaged && (
        <button
          className="userInfo__manage-in-group-button"
          onClick={onClickManageInGroup}
        >
          Manage in group
        </button>
      )}
    </div>
  )
}

export default UserInfo
